var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useV2)?_c('DocumentDetailV2',{attrs:{"document":_vm.document}}):_c('DocumentDetail',{attrs:{"document":_vm.document}})}
var staticRenderFns = []

export { render, staticRenderFns }